import { IRuntimeFrameworkContext } from '@farris/devkit';
import { GspFramework } from '../types';
import { RuntimeFrameworkContextService } from './runtime-framework-context.service';

/**
 * è¿è¡æ¡æ¶ä¸ä¸æ
 */
export class RuntimeFrameworkContext implements IRuntimeFrameworkContext {
  userId: string;
  languageId: string;
  userCode: string;
  userName: string;
  orgId: string;
  orgName: string;
  unitId: string;
  unitName: string;
  constructor(userInfo: GspFramework.UserInfo) {
    if (userInfo) {
      this.userId = userInfo.id;
      this.userCode = userInfo.code;
      this.userName = userInfo.name;
      this.orgId = userInfo.orgId;
      this.orgName = userInfo.orgName;
      this.languageId = userInfo.languageId;
      this.unitId = userInfo.unitId;
      this.unitName = userInfo.unitName;
    }
  }
}
/**
 * è¿è¡æ¡æ¶ä¸ä¸æå®ä¾åå·¥å
 * @param runtimeFrameworkContextService -è¿è¡æ¡æ¶ä¸ä¸ææå¡
 * @returns {IRuntimeFrameworkContext} -è¿è¡æ¡æ¶ä¸ä¸æ
 */
export function runtimeFrameworkContextFactory(runtimeFrameworkContextService: RuntimeFrameworkContextService) {
  return runtimeFrameworkContextService.runtimeFrameworkContext;
}
